module.exports = __webpack_public_path__ + "static/img/7339_phase_function_Paper_PointsHejduk_Prediction.2ca984d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7339_phase_function_Paper_PointsHejduk_Prediction.png
// module id = WIzu
// module chunks = 0